import api, { endpoints, apiUtils } from './api';

export const authService = {
  login: async (credentials) => {
    try {
      const response = await api.post(endpoints.auth.login, credentials);
      const data = apiUtils.extractData(response);
      return data;
    } catch (error) {
  if (process.env.NODE_ENV !== 'production') console.error('authService: login error');
      throw new Error(apiUtils.handleApiError(error));
    }
  },

  register: async (userData) => {
    try {
      const response = await api.post(endpoints.auth.register, userData);
      return apiUtils.extractData(response);
    } catch (error) {
      throw new Error(apiUtils.handleApiError(error));
    }
  },

  logout: async () => {
    try {
      await api.post(endpoints.auth.logout);
      localStorage.removeItem('token');
    } catch (error) {
      localStorage.removeItem('token');
      if (process.env.NODE_ENV !== 'production') console.error('logout error');
    }
  },

  getCurrentUser: async () => {
    try {
      const response = await api.get(endpoints.auth.me);
      return apiUtils.extractData(response);
    } catch (error) {
      throw new Error(apiUtils.handleApiError(error));
    }
  },

  refreshToken: async () => {
    try {
      const response = await api.post(endpoints.auth.refresh);
      const data = apiUtils.extractData(response);
      if (data.token) {
        localStorage.setItem('token', data.token);
      }
      return data;
    } catch (error) {
      localStorage.removeItem('token');
      throw new Error(apiUtils.handleApiError(error));
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await api.post(endpoints.auth.forgotPassword, { email });
      return apiUtils.extractData(response);
    } catch (error) {
      throw new Error(apiUtils.handleApiError(error));
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post(endpoints.auth.resetPassword, {
        token,
        password: newPassword,
      });
      return apiUtils.extractData(response);
    } catch (error) {
      throw new Error(apiUtils.handleApiError(error));
    }
  },

  isTokenValid: () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp > currentTime;
    } catch (error) {
      return false;
    }
  },

  getTokenInfo: () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        userId: payload.sub || payload.id,
        email: payload.email,
        role: payload.role,
        exp: payload.exp,
        iat: payload.iat,
      };
    } catch (error) {
      return null;
    }
  },
};
